import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import useDerivedStateFromProps from '@elliemae/ds-utilities/hooks/useDerivedStateFromProps';
import { toggleInObject } from '@elliemae/ds-utilities/utils';
import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import { makeEditableConfig, addEditableToCell } from './decorateEditable.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react';
import 'react-edit';
import '@elliemae/ds-icons/EditPencil';
import '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import './getEditorComponent.js';
import '@babel/runtime/helpers/esm/extends';
import './EditableComponents/ComboBox.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@elliemae/ds-basic/form/ComboBox';
import './EditableComponents/TextBox.js';
import '@elliemae/ds-basic/form/TextBox';

var registerStateHook = function registerStateHook(grid) {
  var _grid$props = grid.props,
      _grid$props$rowKey = _grid$props.rowKey,
      rowKey = _grid$props$rowKey === void 0 ? 'id' : _grid$props$rowKey,
      editingRowsProp = _grid$props.editingRows,
      onColumnRowEdited = _grid$props.onColumnRowEdited,
      onColumnRowEdit = _grid$props.onColumnRowEdit;

  var _useDerivedStateFromP = useDerivedStateFromProps(editingRowsProp || {}),
      _useDerivedStateFromP2 = _slicedToArray(_useDerivedStateFromP, 2),
      editingRows = _useDerivedStateFromP2[0],
      setEditingRows = _useDerivedStateFromP2[1];

  var activateEdit = function activateEdit(editParams) {
    var _grid$getInstance = grid.getInstance(),
        shouldRefocus = _grid$getInstance.shouldRefocus;

    var rowData = editParams.rowData,
        columnIndex = editParams.columnIndex;
    shouldRefocus.current = {
      forced: true,
      value: false
    };
    setEditingRows(function (prevEditingRows) {
      onColumnRowEdit(editParams);
      return toggleInObject(prevEditingRows, rowData[rowKey], columnIndex);
    });
  };

  var editValue = function editValue(_ref) {
    var value = _ref.value,
        rowData = _ref.rowData,
        property = _ref.property,
        rowIndex = _ref.rowIndex;
    setEditingRows({});
    onColumnRowEdited({
      value: value,
      rowData: rowData,
      property: property,
      rowIndex: rowIndex
    });
  };

  return {
    state: {
      editingRows: editingRows
    },
    actions: {
      activateEdit: activateEdit,
      editValue: editValue
    }
  };
};

var decorateColumn = function decorateColumn(column, grid) {
  var _grid$props2 = grid.props,
      _grid$props2$isColumn = _grid$props2.isColumnEditable,
      isColumnEditable = _grid$props2$isColumn === void 0 ? function (col) {
    return col.editable;
  } : _grid$props2$isColumn,
      customHandlers = _grid$props2.customHandlers;
  var editableConfig = makeEditableConfig(grid);
  return isColumnEditable(column) ? addEditableToCell({
    column: column,
    config: editableConfig,
    handlers: customHandlers
  }, grid) : column;
};

var EditablePlugin = createInstancePlugin('editable', {
  registerStateHook: registerStateHook,
  decorateColumn: decorateColumn,
  registerHotKeys: function registerHotKeys(grid) {
    return {
      key: 'enter',
      handler: function handler(_ref2) {
        var rowIndex = _ref2.rowIndex,
            cellIndex = _ref2.cellIndex;

        var _grid$getInstance2 = grid.getInstance(),
            composedRows = _grid$getInstance2.composedRows,
            decoratedColumns = _grid$getInstance2.decoratedColumns,
            activateEdit = _grid$getInstance2.actions.activateEdit,
            isColumnEditable = _grid$getInstance2.props.isColumnEditable;

        if (!isColumnEditable(decoratedColumns[cellIndex])) return;
        var rows = composedRows.rows || composedRows;
        var row = rows[rowIndex];
        if (!row) return;
        activateEdit({
          rowData: row,
          columnIndex: cellIndex
        });
      },
      options: {
        keydown: false,
        keyup: true
      }
    };
  }
});

export { EditablePlugin };
//# sourceMappingURL=EditablePlugin.js.map
